/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { parseProductFromAPI } from '@tcp/core/src/components/features/browse/ProductListingPage/container/ProductListingPage.dataMassage';
import { getImgPath } from '@tcp/core/src/components/features/browse/ProductListingPage/util/utility';
import { getDeviceTypeByOS, isClient } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { executeStatefulAPICall, initiateApiCall } from '../../handler';
import { getDateObject, hashValuesReplace, utilPdpArrayHeader } from '../../../utils/utils';
import { parseDate, compareDate } from '../../../utils/parseDate';
import endpoints from '../../endpoints';

import {
  parseBoolean,
  extractPrioritizedBadge,
  getCartProductAttributes,
} from '../../../utils/badge.util';
import {
  responseContainsErrors,
  ServiceResponseError,
  getFormattedError,
} from '../../../utils/errorMessage.util';
import { isCanada as isCASite, getAPIConfig, getTranslateDateInformation } from '../../../utils';
import { parseStoreOpeningAndClosingTimes } from '../../../utils/parseStoreHours';
import CARTITEMTILE_CONSTANTS from '../../../components/features/CnC/CartItemTile/CartItemTile.constants';
import { UPDATE_ITEM_IN_CART } from '../../config';
import { setLocalStorage } from '../../../utils/localStorageManagement';
import constants, {
  RECALCULATE_CACHE,
  ORDER_TYPE,
} from '../../../components/features/CnC/Checkout/Checkout.constants';

const RES_NULL_ERROR = 'res body is null';

export const ORDER_ITEM_TYPE = {
  BOSS: 'BOSS',
  BOPIS: 'BOPIS',
  ECOM: 'ECOM',
};

export const AVAILABILITY = {
  ...CARTITEMTILE_CONSTANTS.AVAILABILITY,
};

export const COUPON_STATUS = {
  AVAILABLE: 'available',
  EXPIRING_SOON: 'expiration-limit',
  APPLYING: 'applying',
  APPLIED: 'applied',
  PENDING: 'pending',
  REMOVING: 'removing',
  NO_ACTIVE_PROMOTION: 'noactivepromotion',
  APPLY: 'APPLY',
  NO_APPLICABLE_PROMOTION: 'noapplicablepromotion',
};

export const BUTTON_LABEL_STATUS = {
  APPLY: 'APPLY',
  REMOVE: 'REMOVE',
};

export const COUPON_REDEMPTION_TYPE = {
  PUBLIC: 'public',
  WALLET: 'wallet',
  REWARDS: 'rewards',
  SAVING: 'saving',
  LOYALTY: 'LOYALTY',
  PLACECASH: 'PLACECASH',
  PC: 'PLACECASH',
  PLACEPERKS: 'placeperks',
  PERKSIMPLICIT: 'PERKS-IMPLICIT',
  PERKSLOYALTY: 'PERKS-LOYALTY',
  BONUSPOINTDAY: 'BONUS-POINT-DAY',
  BENEFITS: 'BENEFITS',
};
export const PLACE_CASH_COUPON_NON_ESPOT = [
  'Unable to apply Place Buck coupon. See terms and conditions for rules. Note: Up to 12 Place Bucks per order.',
];

export const DYNAMIC_PLACE_CASH_THRESHOLD_REACHED_MESSAGE =
  /^Your item total is \$(\d+\.\d{2}) away from being able to redeem this Place Buck coupon\. Please note, clearance items are excluded\.$/;

/**
 * @function constructDateFormat This function creates the date in DD/MM/YY format
 * @param date {Object} The date to be worked on.
 * @return {String} The date in required format.
 */

export const constructDateFormat = (date) => {
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().substr(-2)}`;
};

export const constructDateUTCFormat = (date) => {
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().substr(-2)}`;
};

export const getCouponType = (promotionType) => {
  let offerType = promotionType;
  if (offerType?.includes('PERKS-')) {
    offerType = 'PLACEPERKS';
  }

  switch (offerType) {
    case 'PC':
      return COUPON_REDEMPTION_TYPE.PLACECASH;
    case 'PLACECASH':
      return COUPON_REDEMPTION_TYPE.PLACECASH;
    case 'LOYALTY':
      return COUPON_REDEMPTION_TYPE.REWARDS;
    case 'OTHERS':
      return COUPON_REDEMPTION_TYPE.SAVING;
    case 'PLACEPERKS':
      return COUPON_REDEMPTION_TYPE.PLACEPERKS;
    default:
      return COUPON_REDEMPTION_TYPE.SAVING;
  }
};

const invokePdpApi = (styleNumber) => {
  const apiConfig = getAPIConfig();
  if (apiConfig) {
    const pdpEndpoint = endpoints && endpoints.pdpApi;
    const fetchReviewURL = hashValuesReplace(
      pdpEndpoint.URI,
      utilPdpArrayHeader(styleNumber, {
        brand: apiConfig.brandId && apiConfig.brandId.toUpperCase(),
        lang: apiConfig.language && apiConfig.language.toUpperCase(),
        site: apiConfig.siteId && apiConfig.siteId.toUpperCase(),
      })
    );

    const formattedPdpApiURL = `${fetchReviewURL}`;

    const payload = {
      webService: {
        URI: formattedPdpApiURL,
        method: pdpEndpoint && pdpEndpoint.method,
      },
      skipApiIdentifier: true,
    };

    return executeStatefulAPICall(payload)
      .then((res) => {
        const product = res && res.body && res.body.response && res.body.response.products;
        return parseProductFromAPI(product, product.uniqueId, false, getImgPath, false, false);
      })
      .catch((err) => {
        logger.error('error: ', err);
      });
  }
  return null;
};

/**
 * @method getProductSkuInfoByUnbxd
 * @description - get product info from UNBXD search API.
 * @param {string} productId - productId to fetch from UNBXD
 */
export const getProductSkuInfoByUnbxd = (
  productId,
  itemBrand,
  xappURLConfig,
  isPdpServiceEnabled,
  enablePDPServiceABTest
) => {
  const payload = {
    body: {
      variants: true,
      'variants.count': 100,
      version: 'V2',
      pagetype: 'boolean',
      rows: 20,
      q: productId,
      promotion: false,
      fields: CARTITEMTILE_CONSTANTS.FIELDS_FOR_PROD_DETAILS,
    },
    webService: endpoints && endpoints.getProductSkuInfo,
    brand: itemBrand,
  };
  if (
    (isClient() && isPdpServiceEnabled && enablePDPServiceABTest) ||
    (!isClient() && isPdpServiceEnabled)
  ) {
    return invokePdpApi(productId);
  }
  return initiateApiCall(payload, null, xappURLConfig)
    .then((res) => {
      const product = res && res.body && res.body.response && res.body.response.products;
      return parseProductFromAPI(product, product.uniqueId, false, getImgPath, false, false);
    })
    .catch((err) => {
      logger.error('error: ', err);
    });
};

export const getSwatchImgPath = (id, excludeExtension) => {
  const imageName = id.split('_');
  const imagePath = imageName[0];
  return `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`;
};

export const getProductImgPath = (id, excludeExtension) => {
  const imageName = id.split('_');
  const imagePath = imageName[0];
  return {
    125: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
    380: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
    500: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
    900: `${imagePath}/${id}${excludeExtension ? '' : '.jpg'}`,
  };
};

export const imageGenerator = (id, excludeExtension) => {
  return {
    colorSwatch: getSwatchImgPath(id, excludeExtension),
    productImages: getProductImgPath(id, excludeExtension),
  };
};

const setBrierleyOrderPointsTimeCache = (keyValue) => {
  setLocalStorage({ key: keyValue, value: getDateObject().getTime() });
};

// NOTE: (DT-19681) LOYALTY/PLACECASH/OTHERS
export function getPromotionType(promotionType) {
  switch (promotionType) {
    case 'PC':
      return COUPON_REDEMPTION_TYPE.PLACECASH;
    case 'LOYALTY':
      return COUPON_REDEMPTION_TYPE.LOYALTY;
    default:
      return COUPON_REDEMPTION_TYPE.PUBLIC;
  }
}

export const removeItem = (orderItemId) => {
  const orderItems = [];
  const pushOrderItems = (value) => {
    orderItems.push({
      orderItemId: value,
      quantity: '0',
    });
  };
  if (typeof orderItemId === 'string') {
    orderItems.push({
      orderItemId,
      quantity: '0',
    });
  } else if (Object.prototype.hasOwnProperty.call(orderItemId, 'getUnavailableOOSItems')) {
    orderItemId.getUnavailableOOSItems.forEach((value) => {
      pushOrderItems(value);
    });
  } else {
    orderItemId.forEach((value) => {
      pushOrderItems(value);
    });
  }

  const payload = {
    body: {
      orderItem: orderItems,
    },
    webService: endpoints.updateMultiSelectItemsToRemove,
  };

  return executeStatefulAPICall(payload)
    .then((res) => {
      if (res && !res.body) {
        throw new Error(RES_NULL_ERROR);
        // TODO - Set API Helper to filter if error exists in response
      }
      const orderItemsArray = orderItems.map((item) => item.orderItemId);
      return {
        orderId: res && res.body.orderId,
        orderItems: orderItemsArray,
      };
    })
    .catch((err) => {
      throw err;
    });
};

const defaultUpdateItemPayload = (payloadData) => {
  const { itemId, skuId, quantity, itemPartNumber, variantNo, multipackCatentryId } = payloadData;
  const payload = {
    orderItem: [
      {
        orderItemId: itemId,
        xitem_catEntryId: skuId,
        quantity: quantity && quantity.toString(),
        itemPartNumber,
        variantNo,
      },
    ],
  };
  payload.x_multipackCatentryId = multipackCatentryId || '';
  return payload;
};

/**
 *
 * @method pickUpItemUpdatePayload
 * @description this method handles payload formation for pickupitem
 * @param {*} payloadData
 * @returns
 */
const pickUpItemUpdatePayload = (payloadData) => {
  const { apiPayload } = payloadData;
  return {
    x_calculationUsage: UPDATE_ITEM_IN_CART.X_CALCULATION_USAGE,
    x_isUpdateDescription: UPDATE_ITEM_IN_CART.X_UPDATE_DESCRIPTION,
    ...apiPayload,
  };
};

/**
 *
 * @method payloadFormationForUpdateItem
 * @description this method handles payload formation for update item call for all types of item.
 * @param {*} payloadData
 * @returns
 */
const payloadFormationForUpdateItem = (payloadData) => {
  const { updateActionType } = payloadData;
  switch (updateActionType) {
    case 'UpdatePickUpItem':
      return pickUpItemUpdatePayload(payloadData);
    default:
      return defaultUpdateItemPayload(payloadData);
  }
};

/**
 *
 * @method updateItem
 * @description this method call updateItem API call for all types of item.
 * @param {*} payloadData
 * @returns
 */
export const updateItem = (payloadData, errorMapping) => {
  const updatePayloadData = payloadFormationForUpdateItem(payloadData);
  const { callback } = payloadData;
  const payload = {
    body: {
      ...updatePayloadData,
    },
    webService: endpoints.updateOrderItem,
  };

  return executeStatefulAPICall(payload)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }
      if (callback) {
        callback();
      }
      return {
        orderItemId: res.body.orderItem[0].orderItemId,
      };
    })
    .catch((err) => {
      throw getFormattedError(err, errorMapping);
    });
};

const formatDateStructure = (date) => {
  if (date && date.indexOf('.') + 3 !== date.length - 1) {
    return date.substr(0, date.indexOf('.') + 4);
  }
  return date;
};

const isOnHold = (isOnHoldStatus = false) => {
  if (isOnHoldStatus === true || isOnHoldStatus === 'true') {
    return 'true';
  }
  return isOnHoldStatus;
};

const getFormattedExpirationDate = (validDate, endDate) => {
  let formattedExpirationDate;
  if (validDate instanceof Date) {
    formattedExpirationDate = constructDateUTCFormat(endDate);
  } else {
    formattedExpirationDate = constructDateFormat(endDate);
  }
  return formattedExpirationDate;
};

const getLabelStatus = (itm) => {
  return itm.isApplied ? BUTTON_LABEL_STATUS.REMOVE : BUTTON_LABEL_STATUS.APPLY;
};

const isCouponOnHold = (itm) => {
  return (
    itm.isOnHold === 'true' ||
    itm.isOnHoldApplepay === 'true' ||
    (itm?.isExpired && itm.isApplied) ||
    itm.isOnHold === true
  );
};

const checkDeviceCoupon = (deviceTypebyOS, currentCoupon) => {
  if (deviceTypebyOS && Array.isArray(currentCoupon)) {
    return currentCoupon.some((deviceType) => {
      return deviceTypebyOS?.includes(deviceType);
    });
  }

  return deviceTypebyOS?.includes(currentCoupon);
};

/**
 * @function constructCouponStructure This function parses the coupons got from API
 *                                    to the desired format to be used by FE code
 * @param cpnArray {Array} The array of offers available with user.
 * @return coupons {Array} Array of coupons with each coupons object in desired format.
 */
export const constructCouponStructure = (cpnArray, errorsMapping, deviceSpecificCoupon) => {
  const now = getDateObject();
  const oneDay = 24 * 60 * 60 * 1000;
  const expirationThreshold = 7;
  const coupons = [];
  const deviceTypebyOS = getDeviceTypeByOS();
  cpnArray.forEach((itm) => {
    const currentCoupon = deviceSpecificCoupon && deviceSpecificCoupon[itm.offerCode.toUpperCase()];
    if (currentCoupon && !checkDeviceCoupon(deviceTypebyOS, currentCoupon)) return;

    let labelStatus = getLabelStatus(itm);
    if (isCouponOnHold(itm)) {
      labelStatus = BUTTON_LABEL_STATUS.REMOVE;
    }

    const startDate = parseDate(formatDateStructure(itm.validFrom));
    const endDate =
      itm?.validTo instanceof Date ? itm.validTo : parseDate(formatDateStructure(itm?.validTo));
    const isPlaceCash =
      itm.offerType === COUPON_REDEMPTION_TYPE.PLACECASH || itm.offerType === 'PC';
    const isExpiring =
      Math.round(Math.abs((endDate.getTime() - now.getTime()) / oneDay)) <= expirationThreshold;
    // Mobile coupon Error Handling for web
    let mobileCouponError = '';
    if (itm.isCouponApplicable === false) {
      // eslint-disable-next-line no-underscore-dangle
      mobileCouponError = errorsMapping._APPLIED_MOBILE_CODE_NOT_APPLICABLE;
    }
    coupons.push({
      id: itm.offerCode.toUpperCase(),
      status: itm.isApplied ? COUPON_STATUS.APPLIED : COUPON_STATUS.AVAILABLE,
      labelStatus,
      isExpiring,
      title: itm.offerText,
      detailsOpen: false,
      expirationDate: getFormattedExpirationDate(itm?.validTo, endDate),
      effectiveDate: constructDateFormat(startDate),
      details: itm.offerDescription,
      legalText: itm?.legalText || '',
      isStarted: isPlaceCash ? compareDate(now, startDate) : true,
      offerType: getCouponType(itm.offerType),
      // imageThumbUrl: getCouponImageThumb(itm.offerType),
      // imageUrl: getCouponImage(itm.offerType),
      error: '',
      redemptionType: COUPON_REDEMPTION_TYPE[itm.offerType],
      promotionType: getPromotionType(itm.offerType),
      expirationDateTimeStamp: endDate,
      isExpired: itm.isExpired,
      isApplied: itm?.isApplied,
      promotionId: itm?.promotionId || null,
      isOnHold: isOnHold(itm.isOnHold) || itm.isOnHoldApplepay || 'false',
      originalOfferType: itm.offerType,
      isCouponApplicable: itm.isCouponApplicable,
      mobileCouponError,
      isRedeemed: itm?.isRedeemed,
      couponType: itm?.couponType,
      perkLevel: itm?.perkLevel,
      couponValue: itm?.couponValue || null,
      originalExpiryTime: itm?.validTo,
    });
  });
  return coupons;
};

export const flatCurrencyToCents = (currency = 0) => {
  try {
    return parseFloat(parseFloat(currency.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]).toFixed(2));
  } catch (e) {
    throw new Error(e);
  }
};

export const capitalize = (string) => {
  return string ? string.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
};

export const sanitizeEntity = (string) => {
  return string && typeof string === 'string'
    ? string
        .replace(/&amp;/gi, '&')
        .replace(/&quot;/gi, '"')
        .replace(/&ldquo;/gi, '"')
        .replace(/&acute;/gi, '"')
        .replace(/&prime;/gi, '"')
        .replace(/&bdquo;/gi, '"')
        .replace(/&ldquot;/gi, '"')
        .replace(/\\u0027/gi, "'")
        .replace(/&lsquot;/gi, '"')
        .replace(/%20/gi, ' ')
    : string;
};

const deriveBossInventoryMismatch = (item) => {
  // RAD-88/86 qty - requested quantity,inventoryAvailBOSS - available quantity at FFMC
  return item.qty > item.inventoryAvailBOSS;
};

export const deriveBossEligiblity = (item, orderDetailsResponse) => {
  return !(
    parseBoolean(item.productInfo.itemTcpBossProductDisabled) ||
    parseBoolean(item.productInfo.itemTcpBossCategoryDisabled) ||
    orderDetailsResponse.bossIntlField
  );
};

const getIsProductOK = ({ orderItemType, stLocId, bopisIntlField }) => {
  return orderItemType === ORDER_ITEM_TYPE.BOPIS && stLocId && !parseBoolean(bopisIntlField);
};

const getIsProductUnavailble = ({ bossIntlField, isStoreBOSSEligible }) =>
  parseBoolean(bossIntlField) || !isStoreBOSSEligible;

const getAvailablityIfIsRadialInv = ({ item, orderDetails }) => {
  const isProductBossEligible = deriveBossEligiblity(item, orderDetails); // product ineligibility added as part of RAD-88, not present earlier in production

  if (item.inventoryAvailBOSS <= 0) {
    return AVAILABILITY.UNAVAILABLE;
  }
  if (deriveBossInventoryMismatch(item)) {
    return AVAILABILITY.REQ_QTY_UNAVAILABLE;
  }
  if (!isProductBossEligible) {
    return AVAILABILITY.BOSSINELIGIBLE;
  }

  return AVAILABILITY.OK;
};

const getDefaultAvailability = ({ item }) => {
  if (item.inventoryAvail > 0) {
    return AVAILABILITY.OK;
  }
  return AVAILABILITY.UNAVAILABLE;
};

export const deriveItemAvailability = (orderDetails, item, store, isRadialInvEnabled) => {
  const { bopisIntlField, bossIntlField } = orderDetails;
  const { stLocId, orderItemType } = item;

  if (getIsProductOK({ orderItemType, stLocId, bopisIntlField })) {
    return AVAILABILITY.OK;
  }
  if (item.orderItemType === ORDER_ITEM_TYPE.BOSS && item.stLocId) {
    const isStoreBOSSEligible = store
      ? parseBoolean(store.shippingAddressDetails.isStoreBOSSEligible)
      : true;
    /**
     * Adding new check to return status unavailable in case of:
     * 1. international order - exisiting
     * 2. boss store ineligible - exisiting
     * 3. boss item inventory zero - added with RAD-88/RAD-86
     * 4. boss item inventory mismatch(requested qty > avail qty) - added with RAD-88/RAD-86
     * 5. boss product ineligible -  added with RAD-88/RAD-86
     * returning respective updated Error copies(RAD-86)
     */
    if (getIsProductUnavailble({ bossIntlField, isStoreBOSSEligible })) {
      return AVAILABILITY.UNAVAILABLE;
    }
    if (isRadialInvEnabled) {
      return getAvailablityIfIsRadialInv({ item, orderDetails });
    }
    return getDefaultAvailability({ item });
  }
  if (item.qty > item.inventoryAvail) {
    return AVAILABILITY.UNAVAILABLE;
  }
  if (item.inventoryAvail > 0) {
    // inventory check for BOSS and ECOM
    return AVAILABILITY.OK;
  }
  return AVAILABILITY.UNAVAILABLE;
};

const getMPackItemsForEDD = (item) => {
  if (!item.multiPack) {
    return null;
  }
  return {
    multiPackSKUs: item.multiPackSKUs,
  };
};

/* eslint-disable complexity, max-statements */
export const getCurrentOrderFormatter = (
  orderDetailsResponseObj,
  excludeCartItems,
  isCanada,
  isRadialInvEnabled
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const orderDetailsResponse = orderDetailsResponseObj;
  const EMPTY_OBJECT = Object.create(null);
  let pickUpContact = {};
  let pickUpAlternative = {};
  let isPickupOrder = false;
  let isShippingOrder = false;
  // replaced "BOPIS" with a config variable
  // Check if order is of pickup type instead of just BOPIS
  const mixOrderData =
    orderDetailsResponse.mixOrderDetails && orderDetailsResponse.mixOrderDetails.data;
  const { language } = getAPIConfig();
  let isBossOrder =
    mixOrderData && mixOrderData.find((store) => store.orderType === ORDER_ITEM_TYPE.BOSS);
  let isBopisOrder =
    mixOrderData && mixOrderData.find((store) => store.orderType === ORDER_ITEM_TYPE.BOPIS);
  let isECOM =
    mixOrderData && mixOrderData.find((store) => store.orderType === ORDER_ITEM_TYPE.ECOM);

  const pickupOrder = isBopisOrder || isBossOrder;
  isBopisOrder = !!isBopisOrder;
  isBossOrder = !!isBossOrder;
  isECOM = !!isECOM;
  // show pickup address for both BOSS and BOPIS
  if (pickupOrder) {
    isPickupOrder = true;
    const address = pickupOrder.shippingAddressDetails || {};
    pickUpContact = {
      firstName: address.firstName,
      lastName: address.lastName,
      emailAddress: address.email1,
      phoneNumber: address.phone1,
    };
    const pickUpAltName = address.altName || '';
    pickUpAlternative = {
      firstName: pickUpAltName.substr(0, pickUpAltName.indexOf(' ')),
      lastName: pickUpAltName.substr(pickUpAltName.indexOf(' ') + 1).trim(),
      emailAddress: address.altEmail,
    };
  }

  let shipping = {};
  let smsInfo = {};
  let shippingTotal = undefined; // eslint-disable-line no-undef-init
  let bossCity = '';
  let bossState = '';
  let bopisCity = '';
  let bopisState = '';
  const applePayShippingTotal = flatCurrencyToCents(orderDetailsResponse.finalShippingCharge);
  if (orderDetailsResponse.mixOrderDetails && orderDetailsResponse.mixOrderDetails.data) {
    const orderShippingElement = orderDetailsResponse.mixOrderDetails.data.find(
      // replaced "ECOM" with a config variable
      (element) => element.orderType === 'ECOM'
    );

    // check if cart have boss item.
    const bossItemInCart = orderDetailsResponse.mixOrderDetails.data.find(
      (element) => element.orderType === ORDER_ITEM_TYPE.BOSS
    );

    if (bossItemInCart && bossItemInCart.shippingAddressDetails) {
      const orderAddressInfo = bossItemInCart.shippingAddressDetails;
      bossCity = orderAddressInfo.city;
      bossState = orderAddressInfo.state;
    }
    // check if cart have bopis item.
    const bopisItemInCart = orderDetailsResponse.mixOrderDetails.data.find(
      (element) => element.orderType === ORDER_ITEM_TYPE.BOPIS
    );

    if (bopisItemInCart && bopisItemInCart.shippingAddressDetails) {
      const orderAddressInfo = bopisItemInCart.shippingAddressDetails;
      bopisCity = orderAddressInfo.city;
      bopisState = orderAddressInfo.state;
    }

    if (orderShippingElement) {
      isShippingOrder = true;
    }
    if (orderShippingElement && orderShippingElement.shippingAddressDetails) {
      const orderShippingInfo = orderShippingElement.shippingAddressDetails;
      if (orderShippingInfo.addressId) {
        // orderDetailsResponse.finalShippingCharge may contain garbage that should be ignored if we have no shipping addressId
        shippingTotal = flatCurrencyToCents(orderDetailsResponse.finalShippingCharge);
      }
      shipping = {
        method: {
          shippingMethodId: orderDetailsResponse.shipModeId,
        },
        address: {
          firstName: orderShippingInfo.firstName,
          lastName: orderShippingInfo.lastName,
          addressLine1: orderShippingInfo.addressLine1 || orderShippingInfo.address,
          addressLine2: orderShippingInfo.addressLine2,
          city: orderShippingInfo.city,
          state: orderShippingInfo.state,
          zipCode: (orderShippingInfo.zipCode || '').trim(),
          country: orderShippingInfo.country,
          nickName: orderShippingInfo.addressNickName,
        },
        onFileAddressKey: orderShippingInfo.addressNickName,
        onFileAddressId: orderShippingInfo.addressId && orderShippingInfo.addressId.toString(),
        emailAddress: orderShippingInfo.email1,
        phoneNumber: orderShippingInfo.phone1,
      };
      smsInfo = {
        numberForUpdates: orderShippingInfo.transVibesSmsPhoneNo,
      };
    }
  }
  shipping.emailSignup =
    orderDetailsResponse.mixOrderDetails &&
    orderDetailsResponse.mixOrderDetails.marketingPromoBox === '1';
  const giftWrapItem = orderDetailsResponse.orderItems.find((item) => item.giftOptions);
  const giftWrap = !giftWrapItem
    ? {}
    : {
        optionId: giftWrapItem.itemCatentryId.toString(),
        message: giftWrapItem.giftOptionsMessage || '',
      };

  let stateTax = -1;
  if (orderDetailsResponse.salesTax && orderDetailsResponse.salesTax.salesTax) {
    Object.entries(orderDetailsResponse.salesTax.salesTax).forEach(([country, states]) => {
      if (country) {
        Object.entries(states).forEach(([state, stateTaxValue]) => {
          if (state) {
            if (stateTax === -1) {
              stateTax = 0;
            }

            stateTax += stateTaxValue;
          }
        });
      }
    });
  }
  // When brierley fails, backend returns -1 in these fields
  if (orderDetailsResponse.pointsToNextReward === -1) {
    orderDetailsResponse.pointsToNextReward = null;
  }
  let isBrierleyWorking = true;
  if (orderDetailsResponse.userPoints === -1) {
    orderDetailsResponse.userPoints = null;
    isBrierleyWorking = false;
  }
  let orderType = '';

  if (isECOM && !isBopisOrder && !isBossOrder) {
    // Pure ECOM
    orderType = ORDER_TYPE.PURE_ECOM;
  } else if (isBopisOrder && !isECOM && !isBossOrder) {
    // Pure BopisOrder
    orderType = ORDER_TYPE.PURE_BOPIS;
  } else if (isBossOrder && !isECOM && !isBopisOrder) {
    // Pure BOSS
    orderType = ORDER_TYPE.PURE_BOSS;
  } else if (isECOM && (isBossOrder || isBopisOrder)) {
    orderType = ORDER_TYPE.ECOM_MIX;
  } else if (isBossOrder && isBopisOrder && !isECOM) {
    orderType = ORDER_TYPE.BOSS_AND_BOPIS;
  }

  const usersOrder = {
    emailSignUpTCP: !!orderDetailsResponse.mixOrderDetails.marketingPromoBox,
    emailSignUpGYM: !!orderDetailsResponse.mixOrderDetails.marketingPromoBoxGYM,
    isShippingOrder,
    isPickupOrder,
    isBossOrder,
    isBopisOrder,
    isECOM: isECOM && !isBopisOrder && !isBossOrder,
    orderType,
    orderId: orderDetailsResponse.parentOrderId,
    totalItems: 0,
    appliedGiftCards: [],
    giftWrappingTotal: 0,
    giftDiscountTotal: 0,
    pointsToRedeem: '0',
    savingsTotal: Math.abs(flatCurrencyToCents(orderDetailsResponse.orderDiscountAmount) || 0),
    couponsTotal: 0,
    applePayDisc: flatCurrencyToCents(orderDetailsResponse?.applePayDisc || 0),
    giftCardsTotal: flatCurrencyToCents(orderDetailsResponse.totalGiftCardAmount || 0),
    shippingTotal,
    applePayShippingTotal,
    totalTax:
      stateTax > -1 ? flatCurrencyToCents(orderDetailsResponse.shippingTax) + stateTax : undefined,
    grandTotal: flatCurrencyToCents(orderDetailsResponse.grandTotal),
    subTotal: flatCurrencyToCents(orderDetailsResponse.orderSubTotalBeforeDiscount),
    subTotalWithDiscounts: flatCurrencyToCents(
      orderDetailsResponse.orderSubTotalDiscount ||
        orderDetailsResponse.orderTotalAfterDiscount ||
        0
    ), // DRP-13513 Both attributes have the same value.
    subTotalWithoutGiftCard: flatCurrencyToCents(orderDetailsResponse.orderSubTotalWithoutGiftCard),
    shipModeId: orderDetailsResponse.shipModeId,
    estimatedRewards:
      orderDetailsResponse.userPoints && Math.round(orderDetailsResponse.userPoints),
    isBrierleyWorking,
    estimatedAirMiles: 0, // NOT IN SERVICE RESPONSE - - - Math.round(orderDetailsResponse.airMiles || 0),
    rewardsToBeEarned: parseInt(orderDetailsResponse.valueOfEarnedPcCoupons, 10) || 0, // FIXME: this should have been part of another namespace, however it had to be done.
    earnedReward: orderDetailsResponse.earnedReward || '',
    pointsToNextReward: orderDetailsResponse.pointsToNextReward || 0,
    pointsApi: orderDetailsResponse.pointApi,
    totalOrderSavings: flatCurrencyToCents(orderDetailsResponse.orderTotalSaving || 0),
    checkout: {
      pickUpContact,
      pickUpAlternative,
      shipping,
      billing: {},
      giftWrap,
      smsInfo,
    },
    orderItems: [],
    stores: [],
    loyaltyCallEnabled: orderDetailsResponse.loyaltyCallEnabled,
    loyaltyPointsRequestPayload: {
      loyaltyOrderItems: orderDetailsResponse.orderItems,
      isElectiveBonus: orderDetailsResponse.isElectiveBonus,
      orderId: orderDetailsResponse.parentOrderId,
      orderSubTotal: orderDetailsResponse.orderSubTotal,
      orderSubTotalBeforeDiscount: orderDetailsResponse.orderSubTotalBeforeDiscount,
      orderSubTotalDiscount: orderDetailsResponse.orderSubTotalDiscount,
      orderSubTotalWithoutGiftCard: orderDetailsResponse.orderSubTotalWithoutGiftCard,
      orderTotalAfterDiscount: orderDetailsResponse.orderTotalAfterDiscount,
      orderTotalListPrice: orderDetailsResponse.orderTotalListPrice,
      orderTotalSaving: orderDetailsResponse.orderTotalSaving,
      mprId: orderDetailsResponse.mprId,
    },
    bossCity,
    bossState,
    bopisCity,
    bopisState,
  };

  if (orderDetailsResponse.airMiles) {
    usersOrder.airmiles = {
      accountNumber: orderDetailsResponse.airMiles.airMilesAccount,
      promoId: orderDetailsResponse.airMiles.airMilesDeal,
    };
  }

  if (
    (orderType === ORDER_TYPE.PURE_BOPIS || orderType === ORDER_TYPE.PURE_BOSS) &&
    orderDetailsResponse.mixOrderDetails &&
    orderDetailsResponse.mixOrderDetails.data &&
    orderDetailsResponse.mixOrderDetails.data.length &&
    orderDetailsResponse.mixOrderDetails.data[0] &&
    orderDetailsResponse.mixOrderDetails.data[0].subOrderId
  ) {
    usersOrder.subOrderId = orderDetailsResponse.mixOrderDetails.data[0].subOrderId;
  }

  if (orderDetailsResponse.orderLevelPromos && orderDetailsResponse.orderLevelPromos.explicit) {
    orderDetailsResponse.orderLevelPromos.explicit.forEach((item) => {
      Object.keys(item).forEach((promoCode) => {
        usersOrder.couponsTotal += Math.abs(flatCurrencyToCents(item[promoCode].price));
      });
    });
  }

  usersOrder.savingsTotal -= usersOrder.couponsTotal;

  // UGLY: I guess rounding causes this to be non zero in some cases
  // (or backend sending incorrect numbers)
  if (usersOrder.savingsTotal < 0) {
    usersOrder.savingsTotal = 0;
  }
  if (orderDetailsResponse.giftCardDetails) {
    Object.values(orderDetailsResponse.giftCardDetails).forEach((giftCard) => {
      usersOrder.appliedGiftCards.push({
        id: giftCard.piId,
        onFileCardId: giftCard.creditCardId.toString(),
        amountApplied: giftCard.giftAmount,
        endingNumbers: giftCard.giftCardNumber.substr(-4),
        remainingBalance: giftCard.remainingBalance,
      });
    });
  }

  // DT-32443
  // Not sure why payment information is in mixOrderPaymentDetails AND paymentsList...
  // Backend will clear out mixOrderPaymentDetails array if the payment method is inactive in the DB
  // If mixOrderPaymentDetails is empty we should not save billing details and show error message
  const { mixOrderPaymentDetails } = orderDetailsResponse;
  if (mixOrderPaymentDetails && mixOrderPaymentDetails.length > 0) {
    Object.values(orderDetailsResponse.paymentsList).forEach((payment) => {
      if (payment.cardType !== 'GC') {
        // CC or PayPal
        const billingAddress = payment.billingAddressDetails || {};
        const billingFirstName = ((billingAddress && billingAddress.customerName) || '').match(
          /(\w+)/
        );
        const billingLastName = ((billingAddress && billingAddress.customerName) || '').match(
          /(\w+)$/
        );
        let paymentMethod = '';
        switch (payment.cardType) {
          case 'PayPal':
            paymentMethod = 'paypal';
            break;
          case 'VENMO':
            paymentMethod = 'venmo';
            break;
          default:
            paymentMethod = 'creditCard';
        }
        usersOrder.checkout.billing = {
          paymentMethod,
          onFileCardId: (billingAddress.creditCardId || '').toString(), // credit card id from the card book
          paymentId: payment.piId,
          emailAddress: billingAddress.email,
          phoneNumber: billingAddress.phone1,

          address: {
            onFileAddressKey: billingAddress.nickName,
            onFileAddressId: billingAddress.addressId && billingAddress.addressId.toString(),
            sameAsShipping: billingAddress.nickName === shipping.onFileAddressKey,
            firstName: billingFirstName ? billingFirstName[0] : '',
            lastName: billingLastName ? billingLastName[0] : '',
            addressLine1: billingAddress.addressLine1 || billingAddress.address,
            addressLine2: billingAddress.addressLine2,
            city: billingAddress.city,
            state: billingAddress.state,
            zipCode: (billingAddress.zipCode || '').trim(),
            country: billingAddress.country,
          },

          billing: {
            cardNumber: payment.maskedCardNumber,
            isAfterpay: payment.afterpay,
            cardType:
              payment.cardType === 'PayPal' ? 'paypal' : (payment.cardType || '').toUpperCase(),
            expMonth: parseInt(payment.cardExpirationMonth, 10),
            expYear: parseInt(payment.cardExpirationYear, 10),
            cvv: '',
            isExpirationRequired:
              payment.cardType !== 'PLACE CARD' && payment.cardType !== 'PayPal',
            isCVVRequired: payment.cardType !== 'PLACE CARD' && payment.cardType !== 'PayPal',
          },
        };
      }
    });
  }

  if (
    orderDetailsResponse &&
    orderDetailsResponse.mixOrderDetails &&
    orderDetailsResponse.mixOrderDetails.data
  ) {
    Object.values(orderDetailsResponse.mixOrderDetails.data).forEach((store) => {
      if (store.orderType !== 'ECOM') {
        const { shippingAddressDetails = {} } = store;
        usersOrder.stores.push({
          stLocId: shippingAddressDetails.stLocId || '',
          itemsCount: store.itemsCount,
          storeName: capitalize(shippingAddressDetails.storeName),
          orderType: store.orderType,
          address: {
            addressId: shippingAddressDetails.addressId,
            addessKey: shippingAddressDetails.addressNickName,
            address: capitalize(shippingAddressDetails.address),
            addressLine1: capitalize(shippingAddressDetails.addressLine1),
            addressLine2: capitalize(shippingAddressDetails.addressLine2),
            addressLine3: capitalize(shippingAddressDetails.addressLine3),
            city: capitalize(shippingAddressDetails.city),
            state: capitalize(shippingAddressDetails.state),
            country: capitalize(shippingAddressDetails.country),
            zipCode: shippingAddressDetails.zipCode,
          },
          bossStartDate:
            store.orderType === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(shippingAddressDetails.bossMinDate, language)
              : null,
          bossEndDate:
            store.orderType === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(shippingAddressDetails.bossMaxDate, language)
              : null,
          storeHours: shippingAddressDetails.storeHours,
          isStoreBOSSEligible: parseBoolean(shippingAddressDetails.isStoreBOSSEligible),
        });
      }
    });
  }
  const isUSStore = !isCASite();
  usersOrder.totalItems =
    orderDetailsResponse.orderItems && orderDetailsResponse.orderItems.length === 0
      ? orderDetailsResponse.cartCount
      : 0;
  Object.values(orderDetailsResponse.orderItems).forEach((itemValue) => {
    const item = itemValue;
    const sizeAndFit = item.productInfo.itemsAttributes[item.itemCatentryId.toString()];
    // When brierley fails, backend returns -1
    if (item.itemPoints === -1) {
      item.itemPoints = null;
    }
    // making pickup page visible for BOSS items as well
    // replaced "BOPIS" and "BOSS" with a config variable
    const store =
      (item.orderItemType === ORDER_ITEM_TYPE.BOPIS ||
        item.orderItemType === ORDER_ITEM_TYPE.BOSS) &&
      item.stLocId &&
      orderDetailsResponse.mixOrderDetails &&
      orderDetailsResponse.mixOrderDetails.data
        ? orderDetailsResponse.mixOrderDetails.data.find(
            (storeData) =>
              storeData.shippingAddressDetails &&
              storeData.shippingAddressDetails.stLocId === item.stLocId &&
              storeData.orderType === item.orderItemType
          )
        : null;

    if (!item.giftOptions) {
      usersOrder.totalItems += parseInt(item.qty, 10);

      const { todayOpeningTime, todayClosingTime, tomorrowOpeningTime, tomorrowClosingTime } =
        parseStoreOpeningAndClosingTimes(store);

      const isGiftCard = item.giftItem;
      const giftCardSize = isGiftCard ? item.itemUnitDstPrice : '';
      usersOrder.orderItems.push({
        productInfo: {
          generalProductId: isGiftCard ? item.itemCatentryId.toString() : item.productId,
          //  product part number for Unbxd API call
          productPartNumber: item.productInfo && item.productInfo.productPartNumber,
          skuId: isGiftCard ? item.productId : item.itemCatentryId.toString(),
          itemPartNumber: item.itemPartNumber,
          variantNo: item.variantNo,
          name: sanitizeEntity(item.productInfo.productName),
          imagePath: imageGenerator(item.productInfo.productPartNumber).productImages[500],
          upc: item.itemPartNumber,
          size: sizeAndFit ? sizeAndFit.TCPSize : giftCardSize, // giftCard Size is its price
          fit: sizeAndFit ? sizeAndFit.TCPFit : null, // no fit for gift cards
          pdpUrl: item.productUrl.replace(/&amp;/g, '&'),
          color: {
            name: item.productInfo.productColor
              ? item.productInfo.productColor
              : item.productInfo.productName,
          },
          isGiftCard,
          colorFitSizeDisplayNames: isGiftCard ? { color: 'Design', size: 'Value' } : EMPTY_OBJECT,
          // added to read type of order for the item
          orderType: item.orderItemType,
          itemBrand: item.itemBrand || 'TCP',
          multiPack: item.multiPack,
          multiPackItems: item.multiPackItems,
          tcpStyleQty: isUSStore
            ? item.productInfo.itemTCPStyleQTYUS
            : item.productInfo.itemTCPStyleQTYCA,
          tcpStyleType: isUSStore
            ? item.productInfo.itemTCPStyleTypeUS
            : item.productInfo.itemTCPStyleTypeCA,
          seoToken: item.c_seoToken,
          ...getMPackItemsForEDD(item),
        },
        itemInfo: {
          quantity: parseInt(item.qty, 10),
          itemId: item.orderItemId.toString(),
          itemPoints:
            item.itemPoints || item.itemPoints === 0 ? parseInt(item.itemPoints, 10) : null,
          // This code is misleading - itemPrice and itemDstPrice are not equal to list price/offer price
          // Backend returns the same value for both itemPrice and itemDstPrice UNLESS an explicit promotion is applied
          // Enhancement needed - Backend should return the actual prices and frontend should determine which values to display

          listPrice: flatCurrencyToCents(item.itemPrice),
          offerPrice: flatCurrencyToCents(item.itemDstPrice),
          wasPrice: flatCurrencyToCents(item.productInfo.listPrice),
          itemUnitDstPrice: item.itemUnitDstPrice,
          itemUnitPrice: item.itemUnitPrice,
          // eslint-disable-next-line no-nested-ternary
          salePrice: isGiftCard
            ? flatCurrencyToCents(item.itemUnitPrice)
            : isCanada
            ? flatCurrencyToCents(item.productInfo.offerPriceCAD)
            : flatCurrencyToCents(item.productInfo.offerPrice),
          salesTaxCode: item.itemAtributes?.salesTaxCode,
          discount: item.itemTotalAdjustment || 0,
        },
        miscInfo: {
          clearanceItem: !isCASite()
            ? item.productInfo.itemTCPProductIndUSStore === 'Clearance'
            : item.productInfo.itemTCPProductIndCanadaStore === 'Clearance',
          isOnlineOnly: !isCASite()
            ? Boolean(parseInt(item.productInfo.webOnlyFlagUSStore, 10))
            : Boolean(parseInt(item.productInfo.webOnlyFlagCanadaStore, 10)),
          isBopisEligible: !parseBoolean(orderDetailsResponse.bopisIntlField),
          isBossEligible: deriveBossEligiblity(item, orderDetailsResponse),
          badge: extractPrioritizedBadge(item.productInfo, getCartProductAttributes()),
          isInventoryAvailBOSS: item.inventoryAvailBOSS > 0,
          // onlineInventoryAvailable: item.inventoryAvail,

          // TODO: cleanup structure
          store: store ? capitalize(store.shippingAddressDetails.storeName) : null,
          isStoreBOSSEligible: store
            ? parseBoolean(store.shippingAddressDetails.isStoreBOSSEligible)
            : false,
          // replaced "BOPIS" with a config variable
          // show storeId for both BOSS and BOPIS
          storeId: store && item.stLocId ? item.stLocId : null,
          storeAddress: store
            ? {
                addressLine1: capitalize(store.shippingAddressDetails.addressLine1),
                addressLine2: store.shippingAddressDetails.addressLine2,
                city: capitalize(store.shippingAddressDetails.city),
                state: store.shippingAddressDetails.state,
                zipCode: store.shippingAddressDetails.zipCode.trim(),
              }
            : null,
          // making store details visible for both BOSS and BOPIS
          storePhoneNumber: store ? (store.shippingAddressDetails.phone1 || '').trim() : null,
          storeTodayOpenRange: store ? `${todayOpeningTime} -  ${todayClosingTime}` : null,
          storeTomorrowOpenRange: store ? `${tomorrowOpeningTime} - ${tomorrowClosingTime}` : null,

          availability: deriveItemAvailability(
            orderDetailsResponse,
            item,
            store,
            isRadialInvEnabled
          ),
          vendorColorDisplayId: item.productInfo && item.productInfo.productPartNumber,
          // dates for boss pickup, used getDateInformation utility
          bossStartDate:
            item.orderItemType === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(
                  store && store.shippingAddressDetails.bossMinDate,
                  language
                )
              : null,
          bossEndDate:
            item.orderItemType === ORDER_ITEM_TYPE.BOSS
              ? getTranslateDateInformation(
                  store && store.shippingAddressDetails.bossMaxDate,
                  language
                )
              : null,
          // shows number of items from the store
          storeItemsCount: store ? +store.itemsCount : 0,
          orderItemType: item.orderItemType && item.orderItemType.toUpperCase(),
          itemMprPointsMultiplier: item.productInfo.loyaltyPromoMultiplierUSStore,
          itemPlccPointsMultiplier: item.productInfo.loyaltyPromoPLCCMultiplierUSStore,
          inventoryAvail: item.inventoryAvail,
          inventoryAvailBOSS: item.inventoryAvailBOSS,
          inventoryAvailBOPIS: 0,
        },
      });
    }
  });
  if (orderDetailsResponse.giftWrapItem && orderDetailsResponse.giftWrapItem.length) {
    usersOrder.checkout.giftWrap = {
      optionId: orderDetailsResponse.giftWrapItem[0].catentryId.toString(),
      message: orderDetailsResponse.giftWrapItem[0].giftOptionsMessage || '',
      brand: orderDetailsResponse.giftWrapItem[0].itemBrand || '',
      name: orderDetailsResponse.giftWrapItem[0].name || '',
    };
    usersOrder.giftWrappingTotal = flatCurrencyToCents(
      orderDetailsResponse.giftWrapItem[0].totalPrice
    );
    usersOrder.subTotal -= usersOrder.giftWrappingTotal;
  }
  usersOrder.isPaypalEnabled = parseBoolean(
    orderDetailsResponse.payPalAllowed || orderDetailsResponse.isPayPalAllowed
  );
  usersOrder.cartTotalAfterPLCCDiscount =
    orderDetailsResponse && orderDetailsResponse.cartTotalAfterPLCCDiscount;
  return usersOrder;
};
/* eslint-enable complexity, max-statements */

export const getOrderDetailsData = (
  isCalc = true,
  isRadialInvEnabled = false,
  isRecalcRewards = false
) => {
  const payload = {
    webService: endpoints.getOrderDetails,
    header: {
      calc: isCalc,
      pageName: 'fullOrderInfo',
      langId: -1,
      recalculate: isRecalcRewards,
    },
  };

  return executeStatefulAPICall(payload).then((res) => {
    if (!res.body) {
      throw new Error(RES_NULL_ERROR);
      // TODO - Set API Helper to filter if error exists in response
    }
    if (res.req && res.req.header && res.req.header.recalculate) {
      setBrierleyOrderPointsTimeCache(RECALCULATE_CACHE.ORDER_DETAILS);
    }

    const orderDetailsResponse = res.body;
    return {
      orderDetails: getCurrentOrderFormatter(
        orderDetailsResponse,
        false,
        isCASite(),
        isRadialInvEnabled
      ),
    };
  });
};

export const getProductInfoForTranslationData = (query, brand, xappURLConfig) => {
  return initiateApiCall(
    {
      body: {
        rows: 20,
        variants: true,
        'variants.count': 100,
        version: 'V2',
        'facet.multiselect': true,
        selectedfacet: true,
        id: query,
        promotion: false,
        pagetype: 'boolean',
        fields: CARTITEMTILE_CONSTANTS.FIELDS_FOR_PRODUCT_TRANSLATION,
      },
      webService: endpoints.getProductInfoForTranslationByPartNumber,
      brand,
    },
    null,
    xappURLConfig
  );
};

const getCalcFlag = (calcsEnabled) =>
  calcsEnabled === constants.CALC_VALUE ? calcsEnabled : !!calcsEnabled;

export const getCartData = ({
  calcsEnabled,
  excludeCartItems,
  recalcRewards,
  isCheckoutFlow,
  isRadialInvEnabled,
  isLoggedIn,
  rawCartItems,
  isSourceLogin = false,
  supressCoupons = false,
}) => {
  const payload = {
    webService: endpoints.fullDetails,
    header: {
      pageName: excludeCartItems ? 'excludeCartItems' : 'fullOrderInfo',
      langId: -1,
      source: isLoggedIn || isSourceLogin ? 'login' : '',
      calc: getCalcFlag(calcsEnabled), // new flag (4/30) that enables a BE internal mechanism to compute calcs and taxes,
      recalculate: recalcRewards,
      coupons: !supressCoupons,
    },
  };

  return executeStatefulAPICall(payload).then((res) => {
    if (!res.body) {
      throw new Error(RES_NULL_ERROR);
      // TODO - Set API Helper to filter if error exists in response
    }
    if (res.req && res.req.header && res.req.header.recalculate) {
      setBrierleyOrderPointsTimeCache(RECALCULATE_CACHE.FULL_DETAILS);
    }
    const orderDetailsResponse =
      res.body.orderDetails.orderDetailsResponse || res.body.orderDetails;
    if (excludeCartItems) {
      orderDetailsResponse.orderItems = rawCartItems;
    }
    const coupons = isCheckoutFlow
      ? res.body.coupons
      : res.body.coupons &&
        res.body.coupons.offers &&
        constructCouponStructure(res.body.coupons.offers);
    return {
      coupons,
      orderDetails: getCurrentOrderFormatter(
        orderDetailsResponse,
        excludeCartItems,
        isCASite(),
        isRadialInvEnabled
      ),
    };
  });
};

export const toTimeString = (est) => {
  let hh = est.getHours();
  let mm = est.getMinutes();
  const ampm = hh >= 12 ? ' pm' : ' am';
  hh %= 12;
  hh = hh > 0 ? hh : 12;
  mm = mm < 10 ? `0${mm}` : mm;
  if (hh === 11 && mm === 59 && ampm === ' pm') {
    return 'Midnight';
  }
  return `${hh}:${mm}${ampm}`;
};

export const getUnqualifiedItems = () => {
  // SFCC-TODO
  return new Promise((resolve) => resolve([]));
};

export const startPaypalCheckoutAPI = (orderId, fromPage) => {
  const payload = {
    header: {
      orderId,
      callingPage: fromPage,
      requestType: 'REST',
    },
    webService: endpoints.paypalLookUp,
  };
  return executeStatefulAPICall(payload)
    .then((res = { body: {} }) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }
      return {
        centinelPayload: res.body.Centinel_PAYLOAD,
        centinelOrderId: res.body.Centinel_OrderId,
        centinelRequestPage: res.body.callingPage,
        tcpOrderId: res.body.orderId,
        paypalInContextToken: res.body.processorTransactionId,
      };
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

export const paypalAuthorizationAPI = (
  tcpOrderId,
  centinelRequestPage,
  centinelPayload,
  centinelOrderId
) => {
  const payload = {
    header: {
      tcpOrderId,
      callingPage: centinelRequestPage,
      PaRes: centinelPayload,
      MD: centinelOrderId,
    },
    webService: endpoints.paypalAuth,
  };
  return executeStatefulAPICall(payload)
    .then((res = { body: {} }) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }
      return {
        success: true,
      };
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};

export default {
  getOrderDetailsData,
  removeItem,
  getCartData,
  getUnqualifiedItems,
  getProductInfoForTranslationData,
  startPaypalCheckoutAPI,
  paypalAuthorizationAPI,
  getProductSkuInfoByUnbxd,
};
